import { useTranslationLabel } from "../hooks/useTranslationLabel"

export const getMemberId = (value: string): number => {
  const parts = value.split("_")
  return parts.length >= 2 && !isNaN(parseInt(parts[1]))
    ? parseInt(parts[1])
    : 0
}

export type CategoryItem = {
  label: string
  value: string
}
export const useGenerateCategories = (): CategoryItem[] => {
  const { ALL_CATEGORIES } = useTranslationLabel()
  let items: CategoryItem[] = [{ label: ALL_CATEGORIES, value: "" }]
  return items
}

export const parseQuery = (queryString: string) => {
  var query: any = {}
  var pairs = (
    queryString[0] === "?" ? queryString.substr(1) : queryString
  ).split("&")
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=")
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "")
  }
  return query
}

export function isValidUrl(urlString: string | URL | any) {
  let url
  try {
    url = new URL(urlString)
  } catch (e) {
    return false
  }
  return url.protocol === "http:" || url.protocol === "https:"
}

export const isDisconnectBtnVisible = (driverStatusId: number, customerTypeId: number | undefined): boolean => {
  return driverStatusId === 2 && customerTypeId === 1;
}
